"use strict";

exports.__esModule = true;

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _react = require("react");

var React = _interopRequireWildcard(_react);

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function SvgShEnvelopeRegular(props) {
  return React.createElement(
    "svg",
    _extends({
      xmlns: "http://www.w3.org/2000/svg",
      viewBox: "0 0 17.031 13.501"
    }, props),
    React.createElement("path", { d: "M15.434 0H1.6A1.644 1.644 0 000 1.688v10.125A1.644 1.644 0 001.6 13.5h13.834a1.644 1.644 0 001.6-1.688V1.688A1.644 1.644 0 0015.434 0zm0 1.688v1.435c-.746.642-1.935 1.64-4.477 3.744-.56.466-1.67 1.585-2.442 1.572-.772.013-1.882-1.106-2.442-1.572-2.542-2.1-3.731-3.1-4.477-3.744V1.688zM1.6 11.813V5.288c.762.642 1.843 1.542 3.491 2.906.727.6 2 1.94 3.428 1.932 1.421.008 2.678-1.308 3.428-1.932a587.19 587.19 0 003.491-2.906v6.525z" })
  );
}

exports.default = SvgShEnvelopeRegular;
module.exports = exports["default"];